import { useAuth0 } from "@auth0/auth0-react";
import { Avatar } from "@mui/material";
import MemberService from "Lib/API/Member";
import Action from "components/ActionPopOver";
import AlertDialog from "components/Dialog";
import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import "./index.scss";
const MembersList = ({ mainContactId, family_members, ...props }) => {
  const [open, setOpen] = useState(false);
  const [memberToRemove, setMemberToRemove] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const history = useHistory();

  const handleDelete = async () => {
    const token = await getAccessTokenSilently();
    if (mainContactId === memberToRemove) {
      setOpen(false);
      return;
    }
    await MemberService.removeContact({ contactID: memberToRemove }, token)
      .then((res) => {
        if (res) {
          setOpen(false);
          props.setRefresh(!props.refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  return (
    <>
      {family_members?.map((member, index) => {
        return (
          <div className="member-card " key={index}>
            <div className="card-content">
              <div className="member-container">
                <div className="member-img">
                  <Avatar
                    className="avatar"
                    style={{
                      background: member.profile_img ? "" : "#4CAF50",
                      height: "40px",
                      borderRadius: "6px",
                      width: "40px",
                    }}
                    alt={`${member.first_name} ${member.last_name}`}
                    src={member.profile_img}
                  >
                    {member.profile_img ? (
                      ""
                    ) : (
                      <div style={{ fontWeight: 600 }}>
                        {(
                          member.first_name[0] + member.last_name[0]
                        ).toUpperCase()}
                      </div>
                    )}
                  </Avatar>
                </div>
                <div className="member-name">
                  {`${member.first_name} ${member.last_name}`}
                  {member?.relationship?.[0] ? (
                    <div className="member-t">{member?.relationship?.[0]}</div>
                  ) : (
                    ""
                  )}
                  <div className="member-t">{`Family ${
                    member.account_permission === "admin" ? "Admin" : "Member"
                  }`}</div>
                </div>
              </div>
              <div className="cursor-pointer mr-2">
                <Action
                  onEditClick={() => {
                    history.push(
                      `/member-details/${member.account_id}/family-member`,
                      member
                    );
                  }}
                  onDeleteClick={() => {
                    setMemberToRemove(member._id);
                    setOpen(true);
                  }}
                  style={{
                    color: "#4D5565",
                    width: "14px",
                    height: "14px",
                  }}
                  checkActive={true}
                />
              </div>
            </div>
          </div>
        );
      })}
      <AlertDialog
        open={open}
        handleClose={() => setOpen(false)}
        onDecline={() => setOpen(false)}
        onAccept={() => handleDelete()}
        title={"Are you sure?"}
        description={`Do you want to delete this member?`}
      />
    </>
  );
};

export default MembersList;
